import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.6666 10.6667H22.6666V5.33337H3.99992C2.53325 5.33337 1.33325 6.53337 1.33325 8.00004V22.6667H3.99992C3.99992 24.88 5.78658 26.6667 7.99992 26.6667C10.2133 26.6667 11.9999 24.88 11.9999 22.6667H19.9999C19.9999 24.88 21.7866 26.6667 23.9999 26.6667C26.2133 26.6667 27.9999 24.88 27.9999 22.6667H30.6666V16L26.6666 10.6667ZM25.9999 12.6667L28.6133 16H22.6666V12.6667H25.9999ZM6.66658 22.6667C6.66658 23.4 7.26658 24 7.99992 24C8.73325 24 9.33325 23.4 9.33325 22.6667C9.33325 21.9334 8.73325 21.3334 7.99992 21.3334C7.26658 21.3334 6.66658 21.9334 6.66658 22.6667ZM10.9599 20C10.2266 19.1867 9.18659 18.6667 7.99992 18.6667C6.81325 18.6667 5.77325 19.1867 5.03992 20H3.99992V8.00004H19.9999V20H10.9599ZM22.6666 22.6667C22.6666 23.4 23.2666 24 23.9999 24C24.7333 24 25.3333 23.4 25.3333 22.6667C25.3333 21.9334 24.7333 21.3334 23.9999 21.3334C23.2666 21.3334 22.6666 21.9334 22.6666 22.6667Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "24",
  cy: "24",
  r: "8",
  fill: "#F8A709"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 20H25V24H23V20Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 26H25V28H23V26Z",
  fill: "white"
})), 'DeliveryWarning', {
  viewBox: '0 0 16 16'
});